module.exports = __webpack_public_path__ + "static/media/culvers_chicago_22_2.9e777f03.png";